// Nahlásit komentář

import { prepareFormData } from '@utils/form';
import { FlashMessage, SVGLoader } from '@components';
import * as els from './forumElements';
import { forumTextarea } from './forumTextarea';
import { updateButtonState } from './forumValidate';
import * as api from './forumApi';
import * as Sentry from '@sentry/browser';

interface NotifyResponseSuccess {
  status: boolean;
}

interface ModalNotifyState {
  commentId: string;
}

//  TODO: unit testy https://cncenter.atlassian.net/browse/FEG-657
export const forumNotifyComment = (): void => {
  // UI a data modalu
  let state: ModalNotifyState;
  const modal = els.modalNotify;

  if (!modal) return;
  const buttonSave: HTMLButtonElement | null = modal.querySelector('[data-save-notify-comment]');
  const textarea = modal.querySelector('textarea') as HTMLTextAreaElement;
  const { threadId } = modal.dataset;
  const modalBody: HTMLElement | null = modal.querySelector('.modal__body');

  if (!buttonSave || !textarea || !threadId || !modalBody) return;

  // Pro všechny tlačítk 'Nahlásit'
  els.buttonsNotify.forEach((button) => {
    // Po kliknutí
    button.addEventListener('click', (eventNotify) => {
      // Přidat 'id' komentáře do stavu
      const { notifyComment: commentId } = (eventNotify.target as HTMLElement).dataset;
      if (commentId) {
        state = { commentId };
      }

      // Vynulovat text v modálním okně
      textarea.value = '';

      // Sledovat počet chybějících znaků & autoheight
      forumTextarea(textarea);

      // Add input listener for validation
      textarea.addEventListener('input', () => {
        updateButtonState({
          textarea,
          button: buttonSave,
        });
      });

      // Initial button state
      updateButtonState({
        textarea,
        button: buttonSave,
      });
    });
  });

  // V modálním okně po kliknutí na tlačítko 'Uložit'
  buttonSave.addEventListener('click', async () => {
    if (buttonSave.hasAttribute('disabled')) return;

    // Schovat UI & přidat loader
    textarea.style.display = 'none';
    const svgLoader: HTMLElement = SVGLoader.create({ addTo: modalBody });

    // Přípravit data
    const { commentId } = state;

    if (!commentId) return;

    const requestData = prepareFormData({
      id_message: commentId,
      reason: textarea.value,
      ajax: '1',
    });

    try {
      const response = await fetch(api.notify(threadId), {
        method: 'POST',
        body: requestData,
      });
      const data: NotifyResponseSuccess = await response.json();

      if (data.status) {
        await FlashMessage({ msg: 'Komentář byl nahlášen.', type: 'success' });
      } else {
        await FlashMessage({
          msg: 'Operace se nepodařila.',
          type: 'error',
        });
      }

      els.closeModal(modal);
      textarea.style.display = 'block';
      if (svgLoader) svgLoader.remove();
    } catch (error) {
      await FlashMessage({
        msg: 'Operace se nepodařila.',
        type: 'error',
      });
      Sentry.captureException(`ForumNotifyComment: Operace se nepodařila. Původní error: ${error}`);
    }
  });
};
